var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompanyLogoPlaceholder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "380px",
    height: "380px",
    viewBox: "0 0 380 380",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.125,92.2413793 L219.125,287.758379 L295,287.758621 L295,295 L85,295 L85,287.758621 L92.25,287.758379 L92.25,92.2413793 L219.125,92.2413793 Z M283,154 C289.627417,154 295,159.372583 295,166 L295,280.847539 L239.628571,280.847539 L227,281 L227,154 L283,154 Z M252.938737,178 L240,178 L240.061263,274 L253,274 L252.938737,178 Z M279,178 L266,178 L266,274 L279,274 L279,178 Z M148.377083,226.206897 L112.791667,226.206897 L112.791667,252.275862 L148.377083,252.275862 L148.377083,226.206897 Z M206.920833,226.206897 L159.85625,226.206897 L159.85625,252.275862 L206.920833,252.275862 L206.920833,226.206897 Z M148.377083,177.931034 L112.791667,177.931034 L112.791667,204 L148.377083,204 L148.377083,177.931034 Z M206.920833,177.931034 L159.85625,177.931034 L159.85625,204 L206.920833,204 L206.920833,177.931034 Z M148.377083,129.655172 L112.791667,129.655172 L112.791667,155.724138 L148.377083,155.724138 L148.377083,129.655172 Z M206.920833,129.655172 L159.85625,129.655172 L159.85625,155.724138 L206.920833,155.724138 L206.920833,129.655172 Z M202.208333,85 L202.208333,88.6206897 L112.791667,88.6206897 L112.791667,85 L202.208333,85 Z",
    id: "Combined-Shape",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompanyLogoPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/companyLogoPlaceholder.9de8cc92f61e66e72d131064a0e2b651.svg";